import clsx from 'clsx';
import { FC, ReactElement, SVGProps } from 'react';
import Style from './tab.module.scss';
import { Tooltip } from 'uikit/tooltip/tooltip.component';
import { isNullOrEmpty } from 'src/helpers/string-helper';
import { ReactComponent as ExclamationIcon } from 'assets/img/common/warning_16.svg';

export type TabItemProps = {
  text: string;
  icon?: ReactElement<SVGProps<any>>;
  className?: string;
  isSelected?: boolean;
  testId?: string;
  onClick?: () => void;
  exclamationMessage?: string;
};

export type TabsProps = {
  /**
   * 'Second by default'
   */
  // TODO: Add styles for 'First' and 'Third' tabs variant
  variant?: 'First' | 'Second' | 'Third';
  tabType?: 'Text' | 'Icon';
  items: TabItemProps[];
  className?: string;
  testId?: string;
};

export const Tabs: FC<TabsProps> = ({ items, className, testId, variant = 'Second', tabType = 'Text' }) => (
  <div data-test-id={testId} className={clsx(Style.tabContainer, className)}>
    {items.map((x, i) => (
      <div
        key={i}
        className={clsx({
          [Style.variantFirst]: variant === 'First',
          [Style.variantSecond]: variant === 'Second',
          [Style.textTabType]: tabType === 'Text',
          [Style.iconTabType]: tabType === 'Icon',
        })}
        data-test-id={x.testId}
        data-is-active={x.isSelected}
        onClick={x.onClick}
      >
        <div className={Style.itemWrapper}>
          {x.text}
          {x.icon}
          <ExclamationMark message={x.exclamationMessage} />
        </div>
      </div>
    ))}
  </div>
);

const ExclamationMark: FC<{ message?: string }> = ({ message }) => {
  if (isNullOrEmpty(message)) return <></>;

  return (
    <Tooltip text={message!} hostStyles={Style.tooltipHost}>
      <ExclamationIcon className={Style.exclamationIcon} />
    </Tooltip>
  );
};
